<template>
	<div class="AccreditTest">
        <!-- <div class="summary_complete_bag">
            <div class="summary_complete">
                <div @click="singleComplete(1)" :class="{ active: singletype === 1 }">sp-api授权</div>
                <div @click="singleComplete(2)" :class="{ active: singletype === 2 }" style="margin-left: 10px;">shopify授权</div>
            </div>
        </div> -->
		<el-form :inline="true" :model="formScreen" ref="formScreen">
			<el-form-item
				label="选择分公司"
				prop="branchCompany"
				v-if="[1].includes(str.type)"
			>
				<el-select
					v-model="formScreen.branchCompany"
					placeholder="请选择"
					@change="selectChange($event, 'sonCompany')"
					value-key="company_id"
					filterable
				>
					<el-option
						v-for="item in branchCompany"
						:key="item.company_id"
						:label="item.companyName"
						:value="item"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item
				label="选择子公司"
				prop="sonCompany"
				v-if="[2, 1].includes(str.type)"
			>
				<el-select
					v-model="formScreen.sonCompany"
					placeholder="请选择"
					value-key="rid"
					@change="selectChange($event, 'branchDepartmentList')"
					filterable
				>
					<el-option
						v-for="item in sonCompany"
						:key="item.company_id"
						:label="item.companyName"
						:value="item"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="选择运营分部门" prop="branchDepartmentValue">
				<el-select
					v-model="formScreen.branchDepartmentValue"
					placeholder="请选择"
					@change="selectChange($event, 'groupList')"
					value-key="rid"
				>
					<el-option
						v-for="item in branchDepartmentList"
						:key="item.value"
						:label="item.departmentName"
						:value="item"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="选择组" prop="groupValue">
				<el-select
					v-model="formScreen.groupValue"
					placeholder="请选择"
					@change="selectChange($event, 'userList')"
					value-key="rid"
				>
					<el-option
						v-for="item in groupList"
						:key="item.value"
						:label="item.groupName"
						:value="item"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="选择角色" prop="userValue">
				<el-select
					v-model="formScreen.userValue"
					placeholder="请选择"
					@change="selectChange($event)"
					value-key="rid"
				>
					<el-option
						v-for="item in userList"
						:key="item.value"
						:label="item.roleUserName"
						:value="item"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="选择活跃状态" prop="active">
				<el-select v-model="active" clearable placeholder="请选择">
				<el-option label="活跃" :value="1"></el-option>
				<el-option label="下架" :value="0"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="选择店铺状态" prop="state">
				<el-select v-model="state" clearable placeholder="请选择">
				<el-option label="正常" :value="1"></el-option>
				<el-option label="删除" :value="0"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-row>
					<el-input
						v-model="SearchInp"
						placeholder="店铺名称、商铺id"
						style="width:250px;"
					></el-input>
					<el-button
						type="primary"
						@click="Search2"
						size="mini"
						style="margin-left:10px;padding:7px 15px;"
						>搜索</el-button
					>
					<el-button
						type="primary"
						@click="formScreenReset"
						size="mini"
						style="padding:7px 15px;"
						>重置</el-button
					>
				</el-row>
			</el-form-item>
		</el-form>
		<div>
			<el-select 
				filterable
				clearable 
				v-model="countryLink" 
				placeholder="请选择国家"
				@change="handleChange($event)">
				<el-option
					v-for="item in options"
					:key="item.id"
					:label="item.countryChinese + ' ' + '(' + item.region + ')'"
					:value="item.id">
				</el-option>
			</el-select>
			<el-button @click="shouquan" type="primary" style="margin-left:10px" :disabled="!countryLink">授权</el-button>
			<el-button @click="exchange" type="primary" style="margin-left:10px" :disabled="url ? false : true">交换刷新令牌</el-button>
			<el-button type="primary" @click="toTutorial" style="margin-left:80px">sp-api教程</el-button>
		</div>
		<!-- <el-button type="primary" v-else>shopify教程</el-button> -->
		<div id="amazon-root"></div>
		<!-- <a href="#" @click="testLogin" id="LoginWithAmazon">
			<img
				border="0"
				alt="Login with Amazon"
				src="https://images-na.ssl-images-amazon.com/images/G/01/lwa/btnLWA_gold_156x32.png"
				width="156"
				height="32"
			/>
		</a> -->
		<div class="ymx_in">
			<el-table
				:data="tableData"
				border
				style="width: 100%;margin-bottom:50px;"
				v-loading="loadingTable"
			>
				<el-table-column
					prop="shop_name"
					label="店铺名称"
					align="center"
				></el-table-column>
				<el-table-column
					prop="sellerId"
					label="商户ID"
					align="center"
				></el-table-column>
				<el-table-column label="授权国家"
					align="center">
					<template slot-scope="scope">
						<div
							v-for="item in tableCountry[scope.$index]"
							:key="item.id"
						>
							{{ item.countryName }}
						</div>
					</template>
				</el-table-column>
				<el-table-column
					align="center"
					prop="authorization_time"
					label="授权时间"
				></el-table-column>
				<el-table-column
					prop="active"
					align="center"
					width="150"
					label="活跃状态"
					>
					<template slot-scope="scope">
						
						<el-switch
						v-model="scope.row.active"
						active-color="#13ce66"
						inactive-color="#ff4949"
						active-text="活跃"
						inactive-text="下架"
						:active-value="1"
						:inactive-value="0"
						@change="handleTableSwitch(scope.row)">
						</el-switch>
						
					</template>
				</el-table-column>
				<el-table-column
					align="center"
					prop="state"
					label="店铺状态"
					width="80"
				>
					<template slot-scope="scope">
						<span :class="scope.row.state == 1 ? 'green-text' : 'red-text'">{{ scope.row.state == 1 ? '正常' : '删除' }}</span>
					</template>
				</el-table-column>
				<el-table-column
					align="center"
					prop="operationName"
					label="运营部/角色"
				></el-table-column>
				<el-table-column
					align="center"
					prop="purchaseName"
					label="采购人员"
				></el-table-column>
				<el-table-column
					width="200"
					prop="fenName"
					label="所属分公司"
					align="center"
					v-if="str.type === 1"
				></el-table-column>
				<el-table-column
					width="200"
					prop="ziName"
					label="所属子公司"
					align="center"
					v-if="[1, 2].includes(str.type)"
				></el-table-column>
				<el-table-column
					fixed="right"
					label="操作"
					width="230"
					align="center"
					v-if="str.type === 3"
				>
					<template slot-scope="scope">
						<div>
							<el-button
								@click="handleClick(scope.row)"
								type="text"
								size="small"
								>更改店铺信息</el-button
							>
						</div>
						<div>
							<el-button
								@click="Delete(scope.row)"
								type="text"
								size="small"
								>删除</el-button
							>
						</div>
						<div>
							<el-button
								@click="distribution(scope.row)"
								type="text"
								size="small"
								>分配</el-button
							>
						</div>
					</template>
				</el-table-column>
			</el-table>

			<div class="page">
				<el-pagination
					style="margin-right:200px;"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-sizes="[50, 100, 200, 400]"
					:page-size="pagesize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</div>
		</div>

		<el-dialog
			title="sp-api授权"
			:visible.sync="EditRefresh"
			width="30%"
			style="margin-top:20px;"
		>
			<div>
				<label style="display: inline-block;width: 100px;">名称：</label
				><el-input
					placeholder="请输入店铺名称"
					v-model="NameValue2"
					style="margin-top:10px;width:70%;"
				></el-input>
			</div>
			<div>
				<label style="display: inline-block;width: 100px;"
					>Amazon账号：</label
				><el-input
					placeholder="请输入账号"
					v-model="amazon_id2"
					style="margin-top:10px;width:70%;"
				></el-input>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="EditRefresh = false">取 消</el-button>
				<el-button type="primary" @click="Submit2">提 交</el-button>
			</div>
		</el-dialog>
		<el-dialog
			title="修改相关信息"
			:visible.sync="EditName"
			width="30%"
			style="margin-top:20px;"
		>
			<div>
				<label style="display: inline-block;width: 100px;">名称：</label
				><el-input
					placeholder="请输入要修改的店铺名称"
					v-model="NameValue1"
					style="margin-top:10px;width:70%;"
				></el-input>
			</div>
			<!-- <div>
				<label style="display: inline-block;width: 100px;"
					>授权令牌：</label
				><el-input
					placeholder="请输入要修改的授权令牌"
					v-model="mwsAuthTokenValue1"
					style="margin-top:10px;width:70%;"
				></el-input>
			</div> -->
			<div>
				<label style="display: inline-block;width: 100px;"
					>Amazon账号：</label
				><el-input
					disabled
					v-model="amazon_id1"
					style="margin-top:10px;width:70%;"
				></el-input>
			</div>
			<!-- <div>
				<label style="display: inline-block;width: 100px;">
					开发者id：</label
				><el-input
					v-model="developerId"
					style="margin-top:10px;width:70%;"
				></el-input>
			</div>
			<p class="hint mt">例如：1234-1234-1234 或 123412341234</p> -->
			<!-- <div v-if="IOSS">
				<label style="display: inline-block;width: 100px;">
					IOSS：</label
				><el-input
					v-model="iossCode"
					placeholder="2位字母加十位数字"
					style="margin-top:10px;width:70%;"
				></el-input>
			</div> -->
			<div slot="footer" class="dialog-footer">
				<el-button @click="EditName = false">取 消</el-button>
				<el-button type="primary" @click="Submit">提 交</el-button>
			</div>
		</el-dialog>
		<el-dialog
			title="店铺分配"
			:visible.sync="shopDistribution"
			width="25%"
			style="margin-top:20px;"
		>
			<el-form
				class="custom-form"
				ref="form"
				label-width="100px"
				label="left"
			>
				<el-form-item label="选择部门">
					<el-select
						v-model="value1"
						@change="choose1"
						placeholder="请选择"
					>
						<el-option
							v-for="item1 in this.arr1"
							v-if="
								item1.departmentName == '运营部' ||
									item1.departmentName == '采购部'
							"
							:key="item1.value"
							:label="item1.departmentName"
							:value="item1"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="选择分部门" v-show="isShow">
					<el-select
						v-model="value2"
						@change="choose2"
						placeholder="请选择"
					>
						<el-option
							v-for="item2 in this.arr2"
							:key="item2.value"
							:label="item2.departmentName"
							:value="item2"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="选择组" v-show="isShow">
					<el-select
						v-model="value3"
						@change="choose3"
						placeholder="请选择"
					>
						<el-option
							v-for="item3 in this.arr3"
							:key="item3.value"
							:label="item3.groupName"
							:value="item3"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="选择员工">
					<el-select
						v-model="value4"
						@change="choose4"
						placeholder="请选择"
					>
						<el-option
							v-for="item4 in this.arr4"
							:key="item4.value"
							:label="item4.roleName"
							:value="item4"
						></el-option>
					</el-select>
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="shopDistribution = false">取消</el-button>
				<el-button
					type="primary"
					@click="Submit1"
					:loading="loadingStatus"
					>分配</el-button
				>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { ajaxPost, Baseurl } from "../../api/api/api";
import { AmazonPost } from '../../api/api/api'
export default {
	name: '',
	components: {},
	props: {},
	data() {
		return {
			active: "",
			state: '',
            // singletype: 1,
			NameValue2: '',
			amazon_id2: '',
			url: '',
			EditName: false,
			EditRefresh: false,
			currentPage: 1,
			pagesize: 50,
			size: 50,
			total: 0,
			options: [],
			tableData: [],
			countryLink: '',
			countryLink1: '',
			countryCode: '',
			SearchInp: '',
			branchCompany: [],
			sonCompany: [],
			branchDepartmentList: [],
			groupList: [],
			userList: [],
			value1: '',
			value2: '',
			value3: '',
			arr1: '',
			arr2: '',
			arr3: '',
			arr4: '',
			value1: '',
			value2: '',
			value3: '',
			value4: '',
			loadingTable: false,
			shopDistribution: false,
			loadingStatus: false,
			str: '',
			sid: '',
			gid: '',
			rid: '',
			isShow: true,
			formScreen: {
				branchCompany: {},
				sonCompany: {},
				departmentValue: {},
				branchDepartmentValue: {},
				groupValue: {},
				userValue: {},
			},
			sellerId1: '',
			NameValue1: '',
			mwsAuthTokenValue1: '',
			amazon_id1: '',
			developerId: '',
			companyId: '',
			staffId: '',
			System: ''
		}
	},
	computed: {},
	watch: {},
	created() {
		this.str = JSON.parse(localStorage.getItem('role'))
		this.url = window.localStorage.getItem("spapi_oauth_code")
		this.getList()
		this.init()
		this.tableList()
	},
	mounted() {
		// let obj = window.localStorage.getItem('query')
		// console.log(JSON.parse(obj))
		this.Deafate()
	},
	methods: {
		handleTableSwitch(item) {
			const API = Baseurl + 'sellerController/updateSellerInfoActive'
			const paramsData = { 
				id: item.id,
				active: item.active
			}
			console.log(paramsData);
			// paramsData.id = item.id
			// paramsData.priority = item.priority

			ajaxPost(API, paramsData).then(res => {
				const { code, data } = res.data
				if (code === 200) {
				this.$message.success('操作成功')
				} else {
				this.Search2()
				this.$message.error(data)
				}
			})
		},
        // singleComplete(val) {
        //     this.singletype = val;
		// 	this.tableList()
        // },
		toTutorial() {
			window.open('https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/sp-api%E6%8E%88%E6%9D%83%E6%95%99%E7%A8%8B.pdf')
		},
		selectChange(item, type) {
			const { rid, system, company_id: companyId } = item
			companyId && (this.companyId = companyId)
			this.getNextPower(rid, system, type)
			if (type === 'sonCompany') {
				this.formScreen.sonCompany = {}
				this.formScreen.departmentValue = {}
				this.formScreen.groupValue = {}
				this.sonCompany = []
				this.departmentList = []
				this.groupList = []
			} else if (type === 'departmentList') {
				this.formScreen.departmentValue = {}
				this.formScreen.branchDepartmentValue = {}
				this.formScreen.groupValue = {}
				this.departmentList = []
				this.branchDepartmentList = []
				this.groupList = []
			} else if (type === 'branchDepartmentList') {
				this.formScreen.branchDepartmentValue = {}
				this.formScreen.groupValue = {}
				this.branchDepartmentList = []
				this.groupList = []
			} else if (type === 'groupList') {
				this.formScreen.groupValue = {}
				this.formScreen.userValue = {}
				this.groupList = []
				this.userList = []
			} else if (type === 'userList') {
				this.formScreen.userValue = {}
				this.userList = []
			}
			this.staffId = rid
			this.System = system
		},
		Submit1() {
			this.$confirm('是否分配该店铺当前时间之前的所有订单', '提示', {
				confirmButtonText: '是',
				cancelButtonText: '否',
				type: 'warning',
			})
				.then(() => {
					this.isAccept = 1
					this.submitAjax()
				})
				.catch(() => {
					this.isAccept = 0
					this.submitAjax()
				})
		},
		submitAjax() {
			var obj = {
				departmentId: this.departmentId,
				departmentChildId: this.departmentChildId,
				gid: this.gid,
				rid: this.rid,
				sid: this.sid,
				isAccept: this.isAccept,
			}
			// console.log(obj);
			this.loadingStatus = true
			ajaxPost(Baseurl + 'sellerController/allotSeller', obj).then(
				(res) => {
					this.loadingStatus = false
					if (res.data.code == 200) {
						this.$message({
							message: '分配店铺成功',
							type: 'success',
						})
						this.tableList()
						this.shopDistribution = false
					} else {
						this.$message.error(res.data.data)
					}
				}
			)
		},
		choose1(val) {
			this.departmentId = val.did
			// console.log(val)
			this.arr2 = []
			this.arr3 = []
			this.arr4 = []
			this.value2 = ''
			this.value3 = ''
			this.value4 = ''

			if (val.kind === 0) {
				this.isShow = true
				var company_id = {
					dgrId: val.dgrId,
					system: 2,
				}
				ajaxPost(
					Baseurl + 'roleController/selectNextInfoByDgrId',
					company_id
				).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						this.arr2 = res.data.data.next
					}
				})
			} else if (val.kind === 1) {
				this.departmentChildId = ''
				this.gid = ''
				this.isShow = false
				var company_id = {
					dgrId: val.dgrId,
					system: 2,
				}
				ajaxPost(
					Baseurl + 'roleController/selectNextInfoByDgrId',
					company_id
				).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						this.arr4 = res.data.data.next
					}
				})
			}
		},
		choose2(val) {
			this.departmentChildId = val.did
			// console.log(val)
			this.arr3 = []
			this.arr4 = []
			this.value3 = ''
			this.value4 = ''
			var company_id = {
				dgrId: val.dgrId,
				system: 3,
			}
			ajaxPost(
				Baseurl + 'roleController/selectNextInfoByDgrId',
				company_id
			).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.arr3 = res.data.data.next
				}
			})
		},
		choose3(val) {
			this.gid = val.gid
			// console.log(val)
			this.arr4 = []
			this.value4 = ''
			var company_id = {
				dgrId: val.dgrId,
				system: 4,
			}
			ajaxPost(
				Baseurl + 'roleController/selectNextInfoByDgrId',
				company_id
			).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.arr4 = res.data.data.next
				}
			})
		},
		choose4(val) {
			this.rid = val.rid
			// console.log(val)
		},
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`)
			this.size = val
			this.tableList()
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`)
			this.currentPage = val
			this.tableList()
		},
		formScreenReset() {
			this.currentPage = 1
			this.$refs.formScreen.resetFields()
			this.branchCompany = []
			this.sonCompany = []
			this.departmentList = []
			this.branchDepartmentList = []
			this.groupList = []
			this.userList = []
			this.SearchInp = ''
			this.state = '';
			this.staffId = this.str.rid
			this.System = this.str.system
			this.tableList()
			this.init()
		},
		init() {
			const {
				rid,
				system,
				company_id: companyId,
				type: companyType,
			} = this.str
			this.companyId = companyId
			this.staffId = rid
			this.System = system
			let type = ''
			if (companyType === 1) {
				type = 'branchCompany'
			} else if (companyType === 2) {
				type = 'sonCompany'
			} else if (system < 3) {
				type = 'branchDepartmentList'
			} else if (system === 3) {
				type = 'groupList'
			} else {
				return
			}
			// this.tableList(type, companyId, rid, system)
			this.getNextPower(rid, system, type)
		},
		getNextPower(rid, system, type) {
			const API = Baseurl + 'roleController/selectNextInfoByRid'
			const paramsData = { rid, system, companyId: this.companyId }
			ajaxPost(API,paramsData)
				.then((res) => {
					const {
						data: { code, data },
					} = res
					if( code === 200 ){
						this[type] = data.next
					}
				})
				.catch((e) => {
					console.log(e)
				})
		},
		tableList() {
			this.loadingTable = true
			const paramsData = {
				isSpapiAuthorize: 1,
				sellerType: 1,
				page: this.currentPage,
				size: this.size,
				company_id: this.companyId,
				rid: this.staffId,
				system: this.System,
				searchString: this.SearchInp,
				active: this.active,
				state: this.state,
			}
			ajaxPost(
				Baseurl + 'sellerController/selectSellerListByRid',
				paramsData
			).then((res) => {
				const { code, data } = res.data
				this.loadingTable = false
				if (code === 200) {
					const {
						next = [],
						sellerInfo: { list, total },
					} = data
					// this[type] = next
					this.tableData = list
					this.total = total
					this.tableCountry = []
					for (var i = 0; i < list.length; i++) {
						this.tableCountry.push(list[i].countryMarks)
					}
				}
				// console.log(this.tableData)
			})
		},
		Search2() {
			this.currentPage = 1
			this.tableList()
		},
		handleChange(event) {
			for(var i = 0; i < this.options.length; i++) {
				if(this.options[i].id === event) {
					this.countryLink1 = this.options[i].sellerCentralUrl
					this.countryCode = this.options[i].countryCode
				}
			}
		},
		Delete(item) {
			// console.log(item)
			this.$confirm('确认删除此条数据', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					var obj = { id: item.id }
					ajaxPost(
						Baseurl + 'sellerController/deleteSellerInfo',
						obj
					).then((res) => {
						if (res.data.code == 200) {
							this.$message({
								type: 'success',
								message: '删除成功!',
							})
							this.tableList()
						} else {
							this.$message.error('删除失败')
						}
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除',
					})
				})
		},
		distribution(val) {
			// console.log(val)
			this.sid = val.id
			this.shopDistribution = true
			var company_id = {
				company_id: this.str.company_id,
			}
			ajaxPost(
				Baseurl + 'roleController/selectDepartmentByCompanyId',
				company_id
			).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.arr1 = res.data.data
				}
			})
		},
		handleClick(item) {
			this.EditName = true
			// console.log(JSON.parse(JSON.stringify(item)))
			// item.countryMarks.area
			// IOSS
			// item.countryMarks.forEach((val) => {
			// 	if (val.area == 'EUR') {
			// 		this.IOSS = true
			// 	} else {
			// 		this.IOSS = false
			// 	}
			// })
			// this.iossCode = item.iossCode
			this.sellerId1 = item.sellerId
			this.NameValue1 = item.shop_name
			this.mwsAuthTokenValue1 = item.mwsAuthToken
			this.amazon_id1 = item.amazon_id
			this.developerId = item.developerId
		},
		Submit() {
			// console.log()
			// return
			// if (this.IOSS) {
			// 	let str = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{12}$/
			// 	if (!str.test(this.iossCode)) {
			// 		this.$message.error('IOSS格式为12位字母+数字组合')
			// 		return
			// 	}
			// }

			var obj = {
				sellerId: this.sellerId1,
				shop_name: this.NameValue1,
				mwsAuthToken: this.mwsAuthTokenValue1,
				developerId: this.developerId,
				// iossCode: this.iossCode,
			}
			ajaxPost(
				Baseurl + 'sellerController/updateShopNameBySellerId',
				obj
			).then((res) => {
				// console.log(res.data)
				if (res.data.code == 200) {
					this.$message({
						message: '修改店铺名成功',
						type: 'success',
					})
					this.tableList()
				} else {
					this.$message.error(res.data.data)
				}
			})
			this.NameValue = ''
			this.EditName = false
		},
		getList() {
			ajaxPost(Baseurl + "countryMarketController/selectCountryMarketList")
				.then(res => {
					this.options = res.data.data
				})
		},
		randomString(e) {
			e = e || 32
			var t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz123456780',
				a = t.length,
				n = ''
			for (let i = 0; i < e; i++)
				n += t.charAt(Math.floor(Math.random() * a))
			return n
		},
		shouquan() {
			// let obj = {
			// 	access_token:
			// 		'Atza|IwEBIEcx6AgeT9rMioBswj7YkEw86eHL-hNu5XX9KY2LaNuohY4T0wcgv3DM-iiqA2KMbSz-JWUIJUa4FxDp96sHShje1qySti_TfdbBno1KLflJlpBHdM8_XD0dXMQofJRAMrR_1nq1T-bacDA6n5_l799NtjACOMNnFQh8y4qnMMpiFR0hfb3DrlqJDAoArgTqeAyg2kxtJyXMPQRQ11JzbjtbOBHhh8MgW9jXfKYttag0SmgMaTJKbinzRW7n0sgRXdVeYWxUdKM2lobiw1yHTOO2brtVuLglZxpFgY063qVCyQ',
			// 	refresh_token:
			// 		'Atzr|IwEBINeqO49WfV_mt5RdW3rtEzhHdepoF4xiCLS1-cENjw-u4L-F9jNFYSRGWKabf10A7f3mCcnshdOva8x83t0U8q2saPmWHvUafF-i9EfspvsUeYRFicCpPBJPaWUVSNMWTIKX7n8I5hrVgENM4LdbsfwdcOW_-EbYjv1mHvQ1Lkr1b2iOl466WMHrxqq5U2i16trOj6jNC327_K2GF2DAMZ8rkeYF4jG3RJ9V5BHN1NVX40SlNwdK_C53w8LrKpMm9MHGWoRfPCIEscISXt6a-sDKSmcLNscSYvgJj_AJAgoUJL9IXE9NYDD9K-f2Rsic5T4',
			// 	token_type: 'bearer',
			// 	expires_in: 3600,
			// }
			// http://www.hyxun.top/?spapi_oauth_code=ANGqGPIWrjvmlWwmzwOm&state=YabMfa3a7KMkcNNawWDfjRAGjiCxjmXZYBd4Dtiwmyet3Ff6dwZetFJ5yANs5WJmnJfHQMFxKDDK71rQ4BRPr05mcwJ7G4SF7TdA0KNefBBXj6w4S38mKzzxiPCWmp6Ft83ZKTSWm7EGfZsmK06a6MaswYZE1wJffrDSSwRffWkFBrSTh0xBzAjDAHRQzR6PGM40w2eGYbhnYZBkfEx5n5FksiXfiG5znd0SWWTn5mXWZejC4dstc883m5WjwhKw&selling_partner_id=A23GOYRE4RL8ST#/login
			// amzn1.sp.solution.313dd9a2-99fc-4852-8dcc-fad2e6ba69fc
			// https://hyxun.top/?spapi_oauth_code=ANYuWWhBUmiOnaNZlHUf&state=c3FJd807fC31QcdynE81H7e8BwpiyT601R1GJ8peii8iwJ56T4TRHFfGDWknsBy2zZ1rp6h8mhNbyCx001MYYdTtMNZ85RszKKeR57CWT6H55Xn82YWDTfABwCmywYnen6WpmdBckBRCZaaQZPdefRtbDBZRD760p1WHrfBTHJFxGJ3Yw0zQaQGTWcxY1D7CKaHpymjsn8aQstPCpB1SiWZ14ny1CZjKMrsKKH5D1BHPz8icJdHJ2nJzTDKn43Ef&selling_partner_id=A23GOYRE4RL8ST
			// spapi_oauth_code:ANPMsRgGsIcuziOOJfMZ
			let id = 'amzn1.sp.solution.f97f477a-3c94-4e19-99c0-a1132baed506'
			let state = this.countryCode
			if(this.countryLink){
				window.location.href = this.countryLink1 + `/apps/authorize/consent?application_id=${id}&state=${state}`
			}
			console.log(this.countryLink);
			window.localStorage.setItem("countryCode",this.countryCode)
		},
		exchange() {
			const API = 'https://api.amazon.com/auth/o2/token'
			const paramsData = {
				 grant_type: 'authorization_code',
				 code: this.url,
				client_id: 'amzn1.application-oa2-client.928d83f4c03e44869f352b82dbbde988',
        		client_secret: 'amzn1.oa2-cs.v1.f20e172c226bf54fd510a4fbb4acc58f138029706edbd8aabe2030a18a8ba0e0'
			}
			ajaxPost(API,paramsData)
				.then((res) => {
					if(res.status == 200){
						this.getSellerId()
						this.$message.success('交换成功!')
						window.localStorage.setItem("access_token",res.data.access_token)
						window.localStorage.setItem("refresh_token",res.data.refresh_token)
					}else{
						this.$message.error('交换失败，请重新授权')
					}
				})
				.catch(() => {
					this.$message.error('交换失败，请重新授权')
				})
		},
		getSellerId() {
			var sellerId = window.localStorage.getItem("selling_partner_id")
			const API = Baseurl + 'sellerController/selectSellerBySellerId'
			const paramsData = {
				 sellerId: sellerId
			}
			ajaxPost(API,paramsData)
				.then((res) => {
					if (res.data.code == 200) {
						this.EditRefresh = true
						if(res.data.data != null) {
							this.amazon_id2 = res.data.data.amazon_id
							this.NameValue2 = res.data.data.shop_name
						}
					} else {
						this.$message.error(res.data.data)
					}
				})
		},
		Submit2() {
			var countryCode = window.localStorage.getItem("state")
			var refreshToken = window.localStorage.getItem("refresh_token")
			var sellerId = window.localStorage.getItem("selling_partner_id")
			const API = Baseurl + 'sellerController/insertSpSellerInfo'
			const paramsData = {
				 countryCode: countryCode,
				 refreshToken: refreshToken,
				 amazon_id: this.amazon_id2,
				 company_id: this.companyId,
				 sellerId: sellerId,
				 shop_name: this.NameValue2
			}
			ajaxPost(API,paramsData)
				.then((res) => {
					if (res.data.code == 200) {
						this.$message.success('授权成功！')
						// 清空url的param数据
						const { pathname, hash } = window.location;
						const newUrl = hash ? pathname + hash : pathname;
						history.replaceState(null, '', newUrl);
						this.EditRefresh = false
						this.tableList()
						this.url = '';
						window.localStorage.removeItem("refresh_token")
						window.localStorage.removeItem("countryCode")
						window.localStorage.removeItem("access_token")
						window.localStorage.removeItem("spapi_oauth_code")
					}else {
						this.$message.error(res.data.data)
					}
				})
		},
		testLogin() {
			let options = {}
			options.scope = 'profile'
			options.state = this.randomString(256)
			options.scope_data = {
				profile: { essential: false },
			}
			amazon.Login.authorize(options, 'https://haihuiselling.com/')
			return false
		},
		Deafate() {
			window.onAmazonLoginReady = function() {
				amazon.Login.setClientId(
					'amzn1.application-oa2-client.928d83f4c03e44869f352b82dbbde988'
				)
			}
			;(function(d) {
				var a = d.createElement('script')
				a.type = 'text/javascript'
				a.async = true
				a.id = 'amazon-login-sdk'
				a.src = 'https://assets.loginwithamazon.com/sdk/na/login1.js'
				d.getElementById('amazon-root').appendChild(a)
			})(document)
		},
	},
}
</script>

<style lang="scss" scoped>
.AccreditTest {
	width: 98%;
	.el-button {
		padding: 9px 15px;
	}
	.el-table {
		margin-top: 20px;
	}
	.page {
		position: fixed;
		width: 100%;
		bottom: 0;
		background-color: white;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 50px;
	}
    .summary_complete_bag {
        overflow: hidden;
        .summary_complete {
            overflow: hidden;
            padding: 10px 0;
            border-bottom: 1px #eee solid;
            div {
                padding: 0 10px;
                height: 30px;
                border: #2c8dff 1px solid;
                line-height: 30px;
                text-align: center;
                color: #2c8dff;
                float: left;
                border-radius: 4px;
                cursor: pointer;
            }
            .active {
                background: #2c8dff;
                color: #fff;
            }
        }
    }
}
.green-text {
	color: #67c23a;

	.el-button {
		padding: 0;
	}
}

.red-text {
	color: #f56c6c;
}
</style>
